import { Container, Content } from './LoadingPage.styles'
import YesLoading from '../YesLoading'
import { LoadingPageProps } from './LoadingPage.types'

export default function LoadingPage({ des, complement }: LoadingPageProps) {
  return (
    <Container>
      <Content>
        <YesLoading />
        {des && <h2>{des}</h2>}
        {complement && <p>{complement}</p>}
      </Content>
    </Container>
  )
}
